import _sfc_main from "./conference.vue2.mjs";
/* empty css                 */
/* empty css                 */
import normalizeComponent from "./_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.conferenceShow ? _c("div", { ref: "roomRef", class: _setup.tuiRoomClass, attrs: { "id": "roomContainer" } }, [_c(_setup.RoomHeader, { directives: [{ name: "show", rawName: "v-show", value: _setup.showRoomTool && _setup.showHeaderTool, expression: "showRoomTool && showHeaderTool" }], staticClass: "header" }), _c(_setup.RoomContent, { directives: [{ name: "tap", rawName: "v-tap.lazy", value: _setup.handleRoomContentTap, expression: "handleRoomContentTap", modifiers: { "lazy": true } }], ref: "roomContentRef", staticClass: "content", attrs: { "show-room-tool": _setup.showRoomTool } }), _c(_setup.RoomFooter, { directives: [{ name: "show", rawName: "v-show", value: _setup.showRoomTool, expression: "showRoomTool" }], staticClass: "footer", on: { "show-overlay": _setup.handleShowOverlay } }), _c(_setup.RoomSidebar), _c(_setup.RoomSetting), _c(_setup.RoomOverlay), _setup.overlayMap.RoomInviteOverlay.visible ? _c(_setup.RoomInviteOverlay) : _vm._e(), _setup.isShowLoading ? _c(_setup.LoadingOverlay) : _vm._e(), _c(_setup.PasswordDialog, { attrs: { "visible": _setup.isShowPasswordContainer }, on: { "join-conference": _setup.enterRoom } })], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "c3c5557a"
);
const ConferenceMainView = __component__.exports;
export {
  ConferenceMainView as default
};
